import React from "react";
// DEVICE DETECT
import { isMobile } from "react-device-detect";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// FONT AWESOME LIBRARY AND ICONS
import { faBuildingCircleCheck } from "@fortawesome/free-solid-svg-icons";
// REDUX
import { useSelector } from "react-redux";
// COMPONENTS
import DrawerRowDivider from "./DrawerRowDivider";
// INTERFACES
import { RootState } from "../../../app/store";

/**
 * Coerce a value to a renderable string when it is a primitive.
 * Returns `null` for objects, arrays, and `undefined` so callers
 * can skip non-displayable fields. Without this guard React throws
 * "Objects are not valid as a React child" and the entire drawer
 * (and any parent tree without an error boundary) blanks out.
 */
function toDisplayString(value: unknown): string | null {
  if (value === null || value === undefined) {
    return null;
  }
  const type = typeof value;
  if (type === "string") {
    return value as string;
  }
  if (type === "number" || type === "boolean" || type === "bigint") {
    return String(value);
  }
  return null;
}

function DrawerOrganizationInformation({ data }: any) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const { theme } = useSelector((state: RootState) => state.home);
  const [t] = useTranslation("global");

  // ************************************************ */
  // USE STATE VARIABLES **************************** */
  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */

  // ************************************************* */
  // USE EFFECT ************************************** */

  // ************************************************ */
  // COMPONENT ************************************** */
  const displayableEntries: Array<{ keyName: string; display: string }> = data
    ? Object.keys(data).reduce<Array<{ keyName: string; display: string }>>((acc, keyName) => {
        const display = toDisplayString((data as Record<string, unknown>)[keyName]);
        if (display !== null) {
          acc.push({ keyName, display });
        }
        return acc;
      }, [])
    : [];

  return (
    <div>
      <br />
      {/** ************************************************* */}
      {/** COMPONENT DRAWER DIVIDER */}
      <DrawerRowDivider
        icon={faBuildingCircleCheck}
        title={t("organizationManagement.organization")}
      />
      {/** ************************************************* */}
      {/** ORGANIZATION INFORMATION */}
      {data && (
        <div className={`drawer__box__${theme}`}>
          {displayableEntries.map(({ keyName, display }) => (
            <div className="generalStyles__flex" key={keyName}>
              <div>
                <p className={isMobile ? "drawer__titleMobile" : "drawer__title"}>
                  {keyName.charAt(0).toUpperCase() + keyName.slice(1).replaceAll("_", " ")}
                </p>
              </div>
              <div className="drawer__textContainer">
                <p className="drawer__text">{display === "" ? "--" : display}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default DrawerOrganizationInformation;
